export default __webpack_public_path__ + "static/media/impact-navbar-logo.05365cb7.png";